// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error[data-v-6f4ba6a2] {\n  background: #D63939;\n}\n.deactivated[data-v-6f4ba6a2] {\n  background-color: #DDDDDD;\n  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAF0lEQVQIW2NkQAP////3YaRQEGQGuhEAFpIQc5htOmUAAAAASUVORK5CYII=);\n}\n.link-active[data-v-6f4ba6a2] {\n  text-decoration: none !important;\n  cursor: pointer;\n}\n.link-inactive[data-v-6f4ba6a2] {\n  text-decoration: none !important;\n  cursor: default;\n}", ""]);
// Exports
module.exports = exports;
